/**
 * STXProfileCard · iter172 (2026-02-27)
 * iter224 · body_type + Labels lokalisiert (t()), Legacy-DE-Werte gemappt.
 */
import { User, Ruler, Weight, Palette, Footprints, Sparkles } from "lucide-react";
import { useTranslation } from "react-i18next";

const BODY_TYPE_LEGACY_TO_CODE = {
  "Schlank": "SLIM", "Sportlich": "SPORTY", "Normal": "NORMAL",
  "Kurvig": "CURVY", "Kräftig": "STRONG", "Athletisch": "SPORTY",
};

export default function STXProfileCard({ facets }) {
  const { t } = useTranslation();
  if (!facets) return null;

  const bodyTypeLabel = (() => {
    if (!facets.body_type) return null;
    const code = BODY_TYPE_LEGACY_TO_CODE[facets.body_type] || facets.body_type;
    return t(`facets.body_type_options.${code}`, {
      defaultValue: { SLIM: "Schlank", SPORTY: "Sportlich", NORMAL: "Normal",
                      CURVY: "Kurvig", STRONG: "Kräftig" }[code] || facets.body_type,
    });
  })();

  const rows = [
    { key: "age_range", label: t("facets.age_range", { defaultValue: "Alter" }), value: facets.age_range, icon: User },
    { key: "height_cm", label: t("facets.height_cm", { defaultValue: "Größe" }), value: facets.height_cm ? `${facets.height_cm} cm` : null, icon: Ruler },
    { key: "weight_kg", label: t("facets.weight_kg", { defaultValue: "Gewicht" }), value: facets.weight_kg ? `${facets.weight_kg} kg` : null, icon: Weight },
    { key: "body_type", label: t("facets.body_type", { defaultValue: "Statur" }), value: bodyTypeLabel, icon: Sparkles },
    { key: "hair_color", label: t("facets.hair_color", { defaultValue: "Haarfarbe" }), value: facets.hair_color, icon: Palette },
    { key: "shoe_size", label: t("facets.shoe_size", { defaultValue: "Schuhgröße" }), value: facets.shoe_size, icon: Footprints },
  ].filter((r) => r.value);

  if (rows.length === 0) return null;

  return (
    <div
      data-testid="stx-profile-card"
      className="mx-4 my-4 rounded-2xl border border-stx-border bg-stx-panel p-4"
    >
      <div className="flex items-center gap-2 mb-3">
        <div className="w-1 h-4 bg-brand-silver rounded-full" />
        <h3 className="text-sm font-bold text-stx-text tracking-wider">
          {t("stx_profile_card.title", { defaultValue: "stilltouchedX Steckbrief" })}
        </h3>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
        {rows.map((r) => {
          const Icon = r.icon;
          return (
            <div
              key={r.key}
              data-testid={`stx-profile-card-${r.key}`}
              className="rounded-xl bg-stx-panel-2 border border-stx-border px-3 py-2"
            >
              <div className="flex items-center gap-1.5 text-[10px] uppercase tracking-wider text-stx-text-dim mb-0.5">
                <Icon size={10} />
                {r.label}
              </div>
              <div className="text-sm font-semibold text-stx-text">{r.value}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
